import React from "react"
import FileGallery from "core/file-gallery"

const ImageUpload = ({ active, onSelect }) => {
  return (
    <FileGallery
      active={active}
      onClose={onSelect}
      allowedFileTypes={["image"]}
    />
  )
}

export default ImageUpload
